// extracted by mini-css-extract-plugin
export default {"flexContainer":"Missed_flexContainer__jG+3O"};